import AddressFormatter from '@fragaria/address-formatter'
import { z } from '@repo/schema'
import { GetAddressComponentSchema } from '@repo/schema/address'

import { formatStreetAddress } from './format-street-address.ts'

export const addressFormatter = (
  address_components?: z.infer<typeof GetAddressComponentSchema>[],
) => {
  if (!address_components) return {}

  const countryCode = address_components.find(comp => comp.types[0] === 'country')?.short_name

  const checkIsCountryCode = (text: string) => (text === countryCode ? undefined : text)

  const address = formatStreetAddress({
    countryCode,
    fallbackCountryCode: null,
    premise: address_components.find(comp => comp.types[0] === 'premise')?.long_name,
    route: address_components.find(comp => comp.types[0] === 'route')?.long_name,
    streetNumber: address_components.find(comp => comp.types[0] === 'street_number')?.long_name,
  })

  const country = AddressFormatter.format(
    {
      country: address_components.find(comp => comp.types[0] === 'country')?.long_name,
    },
    {
      output: 'array',
    },
  )

  const postcode = AddressFormatter.format(
    {
      countryCode,
      postcode: address_components.find(
        comp => comp.types[0] === 'postal_code' || comp.types[0] === 'postal_code_prefix',
      )?.long_name,
    },
    {
      output: 'array',
    },
  )

  const city = AddressFormatter.format(
    {
      city: address_components.find(comp => comp.types[0] === 'locality')?.long_name,
      postalCity: address_components.find(comp => comp.types[0] === 'postal_town')?.long_name,
    },
    {
      output: 'array',
    },
  )

  const neighborhood = AddressFormatter.format(
    {
      countryCode,
      neighbourhood: address_components.find(comp => comp.types[0] === 'neighborhood')?.long_name,
    },
    {
      output: 'array',
    },
  )

  return {
    address,
    city: checkIsCountryCode(city[0]),
    country: checkIsCountryCode(country[0]),
    countryCode: countryCode === 'GB' ? 'UK' : countryCode,
    neighborhood: checkIsCountryCode(neighborhood[0]),
    postcode: checkIsCountryCode(postcode[0]),
    premise: address_components.find(comp => comp.types[0] === 'premise')?.long_name,
  }
}
